import settings from './static/settings.json';
import customizeI18nSettings from './customizeI18nSettings';

export function getGitSettings() {
  return {
    // PACKAGE_VERSION and GIT_COMMIT_ID comes from webpack.DefinePlugin
    gitVersion: PACKAGE_VERSION + ' | ' + GIT_COMMIT_ID // eslint-disable-line no-undef
  };
}

const defaultSettings = {
  ...settings,
  ...getGitSettings(),
  i18n: customizeI18nSettings(settings.i18n)
};

export default defaultSettings;



// WEBPACK FOOTER //
// ./src/defaultSettings.js